module.exports = __webpack_public_path__ + "img/headphones.efcb9277.jpg";